export default __webpack_public_path__ + "static/media/Group 6504@3x.6f88be54.png";